import gql from 'graphql-tag'

import {
  contentFeedItemFragment,
  IContentFeedBoost
} from '../queries/getContentFeeds'

export interface IContentFeedBoostInput {
  itemType: string
  itemId: string
  expiresAt?: string | null
}

export interface ISetContentFeedBoostsVariables {
  contentFeedId: string
  items: IContentFeedBoostInput[]
}

export interface ISetContentFeedBoostsResponse {
  setContentFeedBoosts: IContentFeedBoost[]
}

/**
 * Set-the-whole-list: rank is the array index + 1, so add, remove and reorder
 * are all the same call with a different array. Capped at MAX_FEED_BOOSTS by a
 * DB CHECK, and duplicates are rejected.
 *
 * The selection matches contentFeedBoostsQuery so the result lands in the cache
 * in the same shape the list reads.
 */
export const setContentFeedBoostsMutation = gql`
  mutation setContentFeedBoosts(
    $contentFeedId: String!
    $items: [ContentFeedBoostInput!]!
  ) {
    setContentFeedBoosts(contentFeedId: $contentFeedId, items: $items) {
      rank
      itemType
      itemId
      expiresAt
      item {
        ...ContentFeedItemFields
      }
    }
  }
  ${contentFeedItemFragment}
`

export default setContentFeedBoostsMutation
